export default __webpack_public_path__ + "static/media/rightArrow.2d6cdf97.png";